import { render } from "./News.vue?vue&type=template&id=22cd2a5d&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=22cd2a5d&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cd2a5d"]])

export default __exports__